import { MedicalServiceWithPractitionersSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { createTranslatedText, FormContextValues } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { searchCreator, triggerLabelExtractor } from './GroupSessionsMedicalServiceField.utils';
import { GroupSessionsMedicalServiceFieldFormBeanPart } from './GroupSessionsMedicalServiceField.types';

type GroupSessionsMedicalServiceFieldProps = Pick<
   FormContextValues<GroupSessionsMedicalServiceFieldFormBeanPart>,
   'register'
>;

export const GroupSessionsMedicalServiceField = (props: GroupSessionsMedicalServiceFieldProps): JSX.Element => {
   return (
      <Select<MedicalServiceWithPractitionersSimple>
         testId={'medicalService'}
         triggerLabelExtractor={triggerLabelExtractor}
         controller={props.register('medicalService', { required: false })}
         placeholder={translationKeys.chooseBillingService}
         label={translationKeys.billingService}
         defaultValue={null}
         showClearIcon
         searchInputEnabled
      >
         <Select.SearchCreator searchCreator={searchCreator}>
            {({ items }) => (
               <Select.List<MedicalServiceWithPractitionersSimple> items={items} keyExtractor={'id'}>
                  {(service) => (
                     <Select.Item
                        item={service}
                        testId={service.name}
                        label={<Select.Highlight node={createTranslatedText(service.name)} />}
                     />
                  )}
               </Select.List>
            )}
         </Select.SearchCreator>
      </Select>
   );
};
